export default __webpack_public_path__ + "static/media/rooms1.ce4c5343.png";